import {PlayerViewType} from "../player/models/PlayerTypes";
import {VisualParameters} from "../player/models/parameters/VisualParameters";
import {masteriesService} from "./MasteriesService";
import {userService} from "../user/UserService";
import {i18n} from "../../boot/i18n";

export function getMasterType(playerView: PlayerViewType, visualParameters: VisualParameters) {
  const masterTypeMode = (playerView === 'piano')
    ? 'RHYTHM'
    : 'CHORD';

  const masterTypeHand = (visualParameters.isTimelineContentsDisplayed.LEFT && visualParameters.isTimelineContentsDisplayed.RIGHT)
    ? 'ME'
    : visualParameters.isTimelineContentsDisplayed.LEFT ? 'LEFT'
      : 'RIGHT';

  const masterType = masterTypeHand + '_' + masterTypeMode;

  if (masterType !== 'ME_CHORD') {
    return masterType;
  }
  else {
    return null;
  }
}

export function getScoreDifferenceMap(newScores: any[], oldScores: any[], minDiff: number) {
  return newScores.map((newScoreEntry: any) => {
    const oldEntry: any = oldScores.find((oldScore: any) => {
      return newScoreEntry.id === oldScore.id
      // && oldScore.piano_class_progress < 1 && !oldScore.completed_at // Was used to remove completed entry, but before we returned 0 if old Entry wasn't found
      // Now do it in filter function and for now keep class not hidden since we don't display progress in it
    });
    newScoreEntry.score_diff = (oldEntry) ? newScoreEntry.score - oldEntry.score : newScoreEntry.score
    newScoreEntry.old_score = oldEntry?.score ?? null
    return newScoreEntry
  }).filter((changeScore: any) =>{
    return changeScore.score_diff > minDiff && !changeScore.completed_at
  });
}

export function addScoreDiffToPlayableList(playableList: any[]) {
  return playableList.map((entry) => {
    if (entry.piece_version_id) {
      entry.song_diff = masteriesService.sessionScoreDiff.challenges.find((scoreDiff) => scoreDiff.id === entry.id)?.score_diff ?? 0
    }
    else {
      entry.song_diff = masteriesService.sessionScoreDiff.versions.find((scoreDiff) => scoreDiff.id === entry.id)?.score_diff ?? 0
    }
    return entry
  })
}


/* Teacher Score Description */

type userDifficulty = 'EASY' | 'MATCHING' | 'HARD' | 'REALLY_HARD'
function getDifficultyForUser(difficulty: number): userDifficulty {
  const userCatalogDifficulty = userService.user.level.catalog_difficulty;
  if (userCatalogDifficulty > difficulty) {
    return 'EASY';
  }
  else if (userCatalogDifficulty === difficulty) {
    return 'MATCHING';
  }
  else if (userCatalogDifficulty + 1 === difficulty) {
    return 'HARD';
  }
  else {
    return 'REALLY_HARD';
  }
}

export function getScoreDescription(score: number, difficulty: number, notInteresting = false, contentType: string = 'morceau', progress: number = 0) {
  
  if (progress === 100) {
    return i18n.t('masteriesUtils.completedContent', {contentType}) as string;
  }
  else if(notInteresting) {
    return i18n.t('masteriesUtils.difficultyAdvices.notInteresting', {contentType}) as string;
  }
  else if (progress > 0 && progress < 100 && contentType === 'morceau') {
    return i18n.t('masteriesUtils.progressMessage', {progress: Math.round(progress)}) as string;
  }
  const difficultyForUser = getDifficultyForUser(difficulty);
  if (!score || score < 20) {
    return i18n.t('masteriesUtils.difficultyAdvices.' + difficultyForUser.toLowerCase() + '.score0', {contentType}) as string;
  }
  else if (score < 35) {
    return i18n.t('masteriesUtils.difficultyAdvices.' + difficultyForUser.toLowerCase() + '.score20', {contentType}) as string;
  }
  else if (score < 50) {
    return i18n.t('masteriesUtils.difficultyAdvices.' + difficultyForUser.toLowerCase() + '.score35', {contentType}) as string;
  }
  else if (score < 75) {
    return i18n.t('masteriesUtils.difficultyAdvices.' + difficultyForUser.toLowerCase() + '.score50', {contentType}) as string;
  }
  else if (score === 100) {
    return i18n.t('masteriesUtils.difficultyAdvices.score100', {contentType}) as string;
  }
  else {
    return i18n.t('masteriesUtils.difficultyAdvices.' + difficultyForUser.toLowerCase() + '.score75', {contentType}) as string;
  }
}


